import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinthane() {



const cardData =
{
  keyword: 'Cab Service in Thane',

  heading: 'Lotus Cab: Cab Service in Thane',

headingDescription:
    "Lotus Cabs offers reliable and affordable Cab Service in Thane for local travel, airport transfers, railway station pickups, corporate transportation, business meetings, hotel transfers, family outings, sightseeing tours, outstation trips, and one-way or round-trip journeys. We provide a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup across Thane, well-maintained vehicles, GPS-enabled rides, and a strong commitment to safety, punctuality, and customer satisfaction, Lotus Cabs ensures a smooth, comfortable, and hassle-free travel experience for individuals, families, tourists, and corporate clients.",

  top: 'Top Places to Visit in Thane with Lotus Cab',

  topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most frequently traveled destinations from Thane for business meetings, airport transfers, shopping, medical appointments, tourism, and daily commuting. Lotus Cabs provides reliable taxi services with professional chauffeurs, comfortable vehicles, and timely pickups, ensuring a convenient journey between Thane and Mumbai at affordable prices."
    },
    {
        title: "Mumbai Airport",
        description:
            "Chhatrapati Shivaji Maharaj International Airport is a major travel hub for domestic and international passengers. Lotus Cabs offers dependable Thane to Mumbai Airport taxi services with flight tracking, punctual pickups, and comfortable airport transfers, making every journey stress-free for business travelers, families, and tourists."
    },
    {
        title: "Navi Mumbai",
        description:
            "Navi Mumbai is a rapidly growing business and residential city known for Belapur, Vashi, Nerul, Kharghar, Airoli, and the upcoming Navi Mumbai International Airport. Whether you are traveling for work, meetings, shopping, or local sightseeing, Lotus Cabs ensures a smooth and comfortable ride from Thane."
    },
    {
        title: "Pune",
        description:
            "Pune is among the most popular outstation destinations from Thane, attracting corporate professionals, students, families, and tourists. Lotus Cabs offers one-way and round-trip taxi services via the Mumbai–Pune Expressway with experienced drivers, spacious vehicles, and transparent pricing for a safe and enjoyable journey."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a favorite weekend getaway famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and lush green valleys. Travelers from Thane frequently book Lotus Cabs for relaxing road trips through the scenic Western Ghats, enjoying comfortable travel and breathtaking landscapes."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most beautiful hill stations, known for Venna Lake, Arthur's Seat, strawberry farms, waterfalls, and cool weather. Lotus Cabs provides comfortable Thane to Mahabaleshwar cab services, making family vacations, honeymoon trips, and weekend getaways convenient and memorable."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most important pilgrimage destinations and welcomes millions of Sai Baba devotees every year. Lotus Cabs offers reliable Thane to Shirdi taxi services for one-way, round-trip, and customized pilgrimage packages with comfortable vehicles and experienced chauffeurs."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, Ram Kund, and the Kumbh Mela. Whether you are planning a religious tour, wine tourism, or family vacation, Lotus Cabs ensures safe, comfortable, and affordable transportation from Thane to Nashik."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most popular beach destination, offering beautiful beaches, Portuguese heritage, vibrant nightlife, luxury resorts, churches, and water sports. Lotus Cabs provides long-distance taxi services from Thane to Goa with spacious vehicles and professional drivers, making every road trip comfortable and enjoyable."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a scenic coastal destination known for Alibaug Beach, Kolaba Fort, Kashid Beach, beach resorts, and exciting water sports. Located within convenient driving distance from Thane, it is an excellent destination for weekend holidays, family outings, and beach vacations with Lotus Cabs."
    }
],

  "services": [
    {
      "name": "Cab Service in Thane",
      "description": "Book cab service in Thane for local city travel, office commute, shopping trips, and social visits. AC sedan, SUV, Ertiga, Innova Crysta, and Kia Carens options are available. Transparent per km pricing ensures clear billing without hidden charges. Suitable for daily travel and emergency rides with 24x7 availability."
    },
    {
      "name": "Airport Cab Service Thane",
      "description": "Reliable airport cab service from Thane to Mumbai Airport (T1 & T2). Timely pickup, traffic monitoring, and comfortable vehicles ensure smooth airport transfers."
    },
    {
      "name": "Outstation Cab Service Thane",
      "description": "Outstation cab service from Thane to Pune, Nashik, Lonavala, Shirdi, Goa, and nearby cities. One-way and round-trip options available with clear fare structure."
    },
    {
      "name": "Thane to Pune Cab",
      "description": "Popular Thane to Pune cab route via Mumbai–Pune Expressway offering comfortable intercity travel."
    },
    {
      "name": "Thane to Nashik Cab",
      "description": "Convenient cab service from Thane to Nashik for pilgrimage and wine tourism travel."
    },
    {
      "name": "SUV & 7 Seater Cab in Thane",
      "description": "Spacious SUV and 7-seater cab service suitable for family trips and group travel."
    },
    {
      "name": "Innova Crysta on Rent in Thane",
      "description": "Premium Innova Crysta rental for corporate, wedding, and long-distance travel."
    },
    {
      "name": "Ertiga & Kia Carens Cab Thane",
      "description": "Affordable and spacious MPV options ideal for economical family travel."
    }
  ],

  "tableData": [
    ["Cab Service in Thane", "Airport Cab Service Thane"],
    ["Outstation Cab Service Thane", "Thane to Pune Cab"],
    ["Thane to Nashik Cab", "SUV & 7 Seater Cab in Thane"],
    ["Innova Crysta on Rent in Thane", "Ertiga & Kia Carens Cab Thane"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "24x7 Availability",
      "WhyChoosedescription": "Round-the-clock cab service across Thane."
    },
    {
      "WhyChooseheading": "Transparent Taxi Fare",
      "WhyChoosedescription": "Clear billing without hidden charges."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Experienced chauffeurs familiar with city and highway routes."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Innova, Ertiga, Kia Carens available."
    },
    {
      "WhyChooseheading": "Airport Transfer Support",
      "WhyChoosedescription": "Timely pickup and drop for Mumbai Airport."
    },
    {
      "WhyChooseheading": "Corporate Travel Solutions",
      "WhyChoosedescription": "Reliable transport for meetings and business needs."
    },
    {
      "WhyChooseheading": "Family & Wedding Travel",
      "WhyChoosedescription": "Spacious vehicles for group and event travel."
    },
    {
      "WhyChooseheading": "Safe & Comfortable Ride",
      "WhyChoosedescription": "Well-maintained AC vehicles ensure relaxed journeys."
    }
  ]
}













const faqData = [
  {
    question: 'Does Lotus Cab provide cab service in Thane?',
    answer: 'Yes, Lotus Cab offers reliable and affordable cab service in Thane for local city travel, airport transfers, corporate bookings, and outstation trips.',
  },
  {
    question: 'Which areas in Thane are covered by Lotus Cab?',
    answer: 'Lotus Cab covers all major areas in Thane including Ghodbunder Road, Majiwada, Hiranandani Estate, Wagle Estate, Kasarvadavali, and nearby locations.',
  },
  {
    question: 'What are the charges for cab service in Thane?',
    answer: 'Cab charges depend on distance, trip type (local or outstation), and vehicle category. Lotus Cab provides transparent per km pricing with clear billing and no hidden charges.',
  },
  {
    question: 'Is Thane to Mumbai airport cab service available?',
    answer: 'Yes, Lotus Cab offers timely airport pickup and drop services from Thane to Mumbai Airport and Navi Mumbai Airport.',
  },
  {
    question: 'Can I book a one-way cab from Thane?',
    answer: 'Yes, Lotus Cab provides affordable one-way cab services from Thane to Pune, Nashik, Lonavala, and other outstation destinations.',
  },
  {
    question: 'Which vehicles are available for cab booking in Thane?',
    answer: 'We offer Sedan cars like Dzire and Etios for daily travel and SUVs like Ertiga and Innova Crysta for family and group travel.',
  },
  {
    question: 'Is 24/7 cab service available in Thane?',
    answer: 'Yes, Lotus Cab operates 24/7 cab services in Thane including early morning and late-night travel.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and applicable taxes are charged separately as per actuals. Lotus Cab ensures complete fare transparency before confirming your booking.',
  },
  {
    question: 'Do you provide corporate cab services in Thane?',
    answer: 'Yes, Lotus Cab offers punctual and professional cab services for corporate meetings, office transfers, and business travel in Thane.',
  },
  {
    question: 'How can I book cab service in Thane with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, time, and preferred vehicle to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Sharma',
    feedback: 'Booked Lotus Cab for airport drop from Thane. On-time pickup, clean vehicle, and professional driver. Very reliable service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Patil',
    feedback: 'Excellent cab service in Thane. Transparent pricing and smooth ride experience. Highly recommend Lotus Cab.',
    rating: 5,
  },
];
















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Thane",
"image": "https://lotuscab.com/assets/images/cab-service-in-thane.jpg",
"description": "Book Cab Service in Thane with Lotus Cab for safe, reliable, and affordable local and outstation travel. 24x7 taxi service with Sedan, SUV, and AC cabs, professional drivers, and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "9480"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹10/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/cab-service-in-thane"
}
};













  return (
    <div>
      


<Helmet>
  <title>Cab Service in Thane | 24x7 Local & Outstation Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Cab Service in Thane with Lotus Cab for affordable local and outstation travel. 24x7 taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and doorstep pickup."
/>

<meta
 name="keywords"
 content="Cab Service in Thane, Thane Cab Service, Thane Taxi Service, Local Cab Thane, Outstation Cab Thane, Airport Cab Thane, Cheap Cab Thane, Best Cab Service Thane, Online Cab Booking Thane, Sedan Cab Thane, SUV Cab Thane, 24x7 Taxi Thane, Affordable Cab Thane, Lotus Cab Thane"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinthane;